<template>
  <nav class="menu-container">
    <h3><font color="#6A1D44">11号线</font></h3>
    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
        {
          //岗厦北在列表中有两个站点信息，内容不同，分别为gangxiabei和gangxiabei2，此站点交汇于10号线和11号线
          name: "gangxiabei2",
          title: "岗厦北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "futian",
          title: "福田",
          // icon: "chat",
          exact: true,
        },
        {
          name: "chegongmiao",
          title: "车公庙",
          // icon: "chat",
          exact: true,
        },
        {
          name: "hongshuwannan",
          title: "红树湾南",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huohai",
          title: "后海",
          // icon: "chat",
          exact: true,
        },
        {
          name: "nanshan",
          title: "南山",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qianhaiwan",
          title: "前海湾",
          // icon: "chat",
          exact: true,
        },
        {
          name: "baoan",
          title: "宝安",
          // icon: "chat",
          exact: true,
        },
        {
          name: "bihaiwan",
          title: "碧海湾",
          // icon: "chat",
          exact: true,
        },
        {
          name: "jichang",
          title: "机场",
          // icon: "chat",
          exact: true,
        },
        {
          name: "jichangbei",
          title: "机场北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "fuyong",
          title: "福永",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qiaotou",
          title: "桥头",
          // icon: "chat",
          exact: true,
        },
        {
          name: "tangwei",
          title: "塘尾",
          // icon: "chat",
          exact: true,
        },
        {
          name: "maanshan",
          title: "马安山",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shajing",
          title: "沙井",
          // icon: "chat",
          exact: true,
        },
        {
          name: "houting",
          title: "后亭",
          // icon: "chat",
          exact: true,
        },
        {
          name: "songgang",
          title: "松岗",
          // icon: "chat",
          exact: true,
        },
        {
          name: "bitou",
          title: "碧头",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(67, 47, 221);
    }
  }
}
</style>





